import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { defaultStyle } from "components/Modals";
import { saveBaseLoad } from "api/resources/contracts";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Select from "components/Select";
import { useAppDispatch, useAppSelector } from "hooks";
import { selectOperators } from "store/selectors";
import { fetchAllOperators, fetchBaseLoads } from "store/appSlice";

interface NewBaseLoadModalProps {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  clientId: number;
  setSnackbar: (snackbar: { type: string; message: string }) => void;
}

const NewBaseLoadModal = ({
  setOpenModal,
  clientId,
  setSnackbar,
}: NewBaseLoadModalProps) => {
  const dispatch = useAppDispatch();
  const operators = useAppSelector(selectOperators);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  useEffect(() => {
    dispatch(fetchAllOperators());
  }, [dispatch]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const postData = {
      clientId: clientId,
      operatorId: Number(data.get("operator")),
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      endDate: dayjs(endDate).format("YYYY-MM-DD"),
      quantity: Number(data.get("quantity")),
    };

    saveBaseLoad(postData)
      .then(() => {
        dispatch(fetchBaseLoads(clientId));
        setOpenModal(false);
        setSnackbar({
          type: "success",
          message: "Base load contract added",
        });
      })
      .catch((error) => {
        console.error(error);
        setOpenModal(false);
        setSnackbar({
          type: "success",
          message: "Adding base load contract failed",
        });
      });
  };

  return (
    <Box sx={defaultStyle}>
      <Typography id="modal-modal-title" variant="h5" component="h5">
        Add a new base load contract
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2} sx={{ mt: "1rem", mb: "2rem" }}>
          <Grid item sm={4}>
            <DatePicker
              name="startDate"
              label={"Select start date"}
              slotProps={{
                textField: { size: "small" },
                clearButton: { size: "small" },
              }}
              onChange={(newValue) => {
                setStartDate(newValue);
              }}
            />
          </Grid>
          <Grid item sm={4}>
            <DatePicker
              name="endDate"
              label={"Select end date"}
              slotProps={{
                textField: { size: "small" },
                clearButton: { size: "small" },
              }}
              onChange={(newValue) => {
                setEndDate(newValue);
              }}
            />
          </Grid>
          <Grid item sm={4}>
            <TextField
              type="number"
              id="quantity"
              name="quantity"
              label="Capacity (MW)"
              size="small"
              required
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item sm={12}>
            <Select
              label="Operator"
              id="operator"
              name="operator"
              required
              minWidth="100%"
              options={operators.map((operator) => {
                return { value: operator.id, label: operator.name };
              })}
            />
          </Grid>
          <Grid item sm={12} sx={{ mt: "1rem" }}>
            <Button variant="contained" type="submit">
              Add base load
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default NewBaseLoadModal;
